module.exports = __webpack_public_path__ + "img/japan.528a95c1.svg";